import Link from 'next/link'
import Styles from './breadcrumb.module.css'

const BreadCrumbChild = ({ item, isLast }) => {
 
    return (
        <>
            {isLast ? (
                <div className={Styles.breadCrumbLink}>
                    {item.title}
                </div>
            ) : (
                <>
                    <Link href={item.link ?? "#"} className={Styles.breadCrumbLink}>
                        {item.title}
                    </Link>
                    <span className="lg:text-[1vw] inline-block px-3 lg:px-[0.3vw] align-middle">
                        /
                    </span>
                </>
            )}
        </>

    )
}

export default BreadCrumbChild;